// Crédits des photographies Wikimedia Commons utilisées sur le site.
// Règle permanente : toutes les ressources sont hébergées localement.
// licence : nom affiché ; creditUrl : page du fichier sur Wikimedia Commons.
export const PHOTO_CREDITS = [
  {
    sujet: "Le Penseur, Auguste Rodin († 1917), jardin du musée Rodin, Paris",
    usage: "Accueil — et image de partage social (og:image) du site",
    photographe: "Douglas O'Brien",
    licence: "CC BY-SA 2.0 — image recadrée",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Le_Penseur_in_the_Jardin_du_Mus%C3%A9e_Rodin,_Paris_14_June_2015.jpg",
  },
  {
    sujet: "La Méditerranée, Aristide Maillol († 1944), jardins du Louvre",
    usage: "Courants & mouvements — Figuratif",
    photographe: "Shonagon",
    licence: "CC0",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:La_M%C3%A9diterran%C3%A9e_-_Aristide_Maillol_-_Mus%C3%A9e_du_Louvre_Sculptures_des_jardins_FNAC_9492_-_TU_254.jpg",
  },
  {
    sujet: "Le Cheval majeur, Raymond Duchamp-Villon († 1918), 1914",
    usage: "Courants & mouvements — Abstrait",
    photographe: "Nasher Sculpture Center",
    licence: "Domaine public — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Duchamp-Villon_Cheval_majeur_Nasher_Dallas.jpg",
  },
  {
    sujet: "Danseuse voilée, terre cuite de la Grèce antique (Myrina), musée du Louvre",
    usage: "Matériaux & techniques",
    photographe: "Marie-Lan Nguyen",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Veiled_dancer_Louvre_Myr660.jpg",
  },
  {
    sujet: "Buste de Ptolémée de Maurétanie, marbre romain, musée du Louvre",
    usage: "Matériaux & techniques — Pierre & marbre",
    photographe: "Marie-Lan Nguyen",
    licence: "Domaine public — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Ptolemy_of_Mauretania_Louvre_Ma1887.jpg",
  },
  {
    sujet: "La Montagne, Aristide Maillol († 1944), bronze, 1937",
    usage: "Accueil — carte « Figuratif contemporain » (Panorama)",
    photographe: "Sdegroisse",
    licence: "CC BY-SA 4.0",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Maillol-Aristide_la-montagne-1937-bronze.jpg",
  },
  {
    sujet: "Idoles cycladiques en marbre, 2800–2700 av. J.-C., musée national archéologique d'Athènes",
    usage: "Accueil — carte « Abstraction » (Panorama)",
    photographe: "Zde",
    licence: "CC BY-SA 4.0",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Cycladic_figurines,_marble,_necklace,_silver,_2800-2700_BC,_NAMA,_190967.jpg",
  },
  {
    sujet: "Atelier de moulage : plâtres en cours, outils et établis (musées royaux d'Art et d'Histoire, Bruxelles)",
    usage: "Accueil — section « Acheter en direct de l'atelier »",
    photographe: "Sam Donvil",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Magazijn_afgietselwerkplaats_KMKG_5.jpg",
  },
  {
    sujet: "Figurines dites « de Tanagra », terre cuite, Grèce, IIIe siècle av. J.-C.",
    usage: "Fiche matériau Terre — image d'en-tête",
    photographe: "Giraudon",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Greece_from_the_Coming_of_the_Hellenes_to_AD._14,_page_265,_Tanagra_figurines.jpg",
  },
  {
    sujet: "Pétrissage de la terre à la main avant modelage",
    usage: "Fiche matériau Terre — étape 1 (préparation)",
    photographe: "Kritzolina",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Kneten_von_Ton_vor_der_Verarbeitung_01.jpg",
  },
  {
    sujet: "« La Charité », bozzetto en terre du Bernin († 1680), 1634-1639",
    usage: "Fiche matériau Terre — étape 2 (modelage)",
    photographe: "Fabrizio Garrisi",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_Lorenzo_Bernini,_La_Carit%C3%A0_con_due_putti,_bozzetto_1634-39_-FG.jpg",
  },
  {
    sujet: "Pièces en terre mises à sécher à l'air avant cuisson, photographie ancienne",
    usage: "Fiche matériau Terre — étape 3 (séchage)",
    photographe: "Library of Congress",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Air_drying_pottery_before_kiln_firing._LCCN2016650556.jpg",
  },
  {
    sujet: "Potiers alimentant le four, pinax corinthien, VIe siècle av. J.-C., Berlin",
    usage: "Fiche matériau Terre — étape 4 (cuisson)",
    photographe: "ArchaiOptix",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Corinthian_pinax_-_potters_firing_kiln_-_Berlin_AS_F_608.jpg",
  },
  {
    sujet: "« Vierge à l'Enfant entre deux anges », terre cuite émaillée de Luca della Robbia († 1482), v. 1470, Bargello",
    usage: "Fiche matériau Terre — étape 5 (finition)",
    photographe: "MenkinAlRire",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Luca_della_Robbia,_Madonna_and_Child_with_Angels,_c1470,_Bargello,_Florence.jpg",
  },
  {
    sujet: "Cuisson raku : pièce incandescente enfumée dans la sciure",
    usage: "Fiche matériau Terre — étape 5 (détail raku) et lexique « Raku »",
    photographe: "Dirk Ingo Franke",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Raku_15.06.2014_11-38-06.jpg",
  },
  {
    sujet: "Cuisson raku : la sciure s'enflamme autour de la pièce",
    usage: "Lexique — fiche « Raku »",
    photographe: "Dirk Ingo Franke",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Raku_15.06.2014_11-38-23.jpg",
  },
  {
    sujet: "Matières premières de l'argile : sable, granit concassé, dégraissants",
    usage: "Lexique — fiche « Argile »",
    photographe: "Silar",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:02021_0507_pottery_raw_materials,_admixtures_to_the_potter%27s_clay.jpg",
  },
  {
    sujet: "Pots en terre crue en attente de cuisson",
    usage: "Lexique — fiche « Céramique »",
    photographe: "Bijay chaurasia",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Clay_Pots-BW-IMG_7303.jpg",
  },
  {
    sujet: "Plat à décor d'engobes, Samarcande, Xe-XIe siècle (anonyme), Dallas Museum of Art",
    usage: "Lexique — fiche « Engobe »",
    photographe: "Dallas Museum of Art",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Flat_plate_with_slip-painted_decoration.jpg",
  },
  {
    sujet: "Logo Hydrographie Concept, impression hydrographique sur tout support",
    usage: "Fiche partenaire « Hydrographie Concept » — en-tête (recadré sur la tête du logo) et vignette sur l'accueil",
    photographe: "Image fournie par Hydrographie Concept",
    licence: "Droits fournis par le partenaire — recadrée avec son accord",
    creditUrl: "https://www.hydrographie-concept.fr",
  },
  {
    sujet: "Objet décoré par hydrographie peinture (raquette)",
    usage: "Fiche partenaire « Hydrographie Concept » — photo 1",
    photographe: "Photo fournie par Hydrographie Concept",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://www.hydrographie-concept.fr",
  },
  {
    sujet: "Impression hydrographique sur casque",
    usage: "Fiche partenaire « Hydrographie Concept » — photo 2",
    photographe: "Photo fournie par Hydrographie Concept",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://www.hydrographie-concept.fr",
  },
  {
    sujet: "Décor hydrographique bois sur sculpture d'un chat",
    usage: "Fiche partenaire « Hydrographie Concept » — photo 3",
    photographe: "Photo fournie par Hydrographie Concept",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://www.hydrographie-concept.fr",
  },
  {
    sujet: "Tas de pigments colorés en poudre",
    usage: "Courants & mouvements — Pop",
    photographe: "Kamalakanta777",
    licence: "CC BY-SA 3.0 — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Holi_shop.jpg",
  },
  {
    sujet: "Fontaine Wallace (Charles-Auguste Lebourg, † 1906), Paris",
    usage: "Courants & mouvements — Sculpture urbaine",
    photographe: "David McSpadden",
    licence: "CC BY 2.0 — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Sir_Richard_Wallace_drinking_fountain,_Paris_May_2014.jpg",
  },
  {
    sujet: "Le Lion de Belfort, Auguste Bartholdi († 1904), grès, 22 m",
    usage: "Courants & mouvements — Monumental",
    photographe: "Thomas Bresson",
    licence: "CC BY 3.0 — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:2014-09-15_16-14-55_lion-belfort.jpg",
  },
  {
    sujet: "Le Fourth Plinth vide, Trafalgar Square, Londres",
    usage: "Courants & mouvements — Conceptuel & in situ",
    photographe: "Matt Brown",
    licence: "CC BY 2.0 — image recadrée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Empty_Fourth_Plinth.jpg",
  },
  {
    sujet: "Ambre jaune poli — une résine naturelle fossile",
    usage: "Matériaux & techniques — Résine",
    photographe: "Rhetos",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:B%C3%B6rnstein.jpg",
  },
  {
    sujet: "Galerie de sculptures, Glyptothèque Ny Carlsberg, Copenhague",
    usage: "Accueil — carte « L'œuvre exposée » (Panorama)",
    photographe: "Daderot",
    licence: "CC0",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Danish_sculpture_gallery_-_Ny_Carlsberg_Glyptotek_-_Copenhagen_-_DSC09538.JPG",
  },
  {
    sujet: "Victoire de Samothrace, v. 190 av. J.-C., musée du Louvre",
    usage: "Page « Qu'est-ce qu'un sculpteur contemporain ? »",
    photographe: "Shonagon",
    licence: "CC0 — image recadrée",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Victoire_de_Samothrace_-_Mus%C3%A9e_du_Louvre_-_vue_large.jpg",
  },
  {
    sujet: "Cavalcade, frise ouest du Parthénon, v. 442-438 av. J.-C., British Museum",
    usage: "Lexique — Bas-relief",
    photographe: "Jastrow (Marie-Lan Nguyen)",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Cavalcade_west_frieze_Parthenon_BM.jpg",
  },
  {
    sujet: "Vénus de Milo, v. 130-100 av. J.-C., musée du Louvre",
    usage: "Lexique — Ronde-bosse",
    photographe: "Jastrow (Marie-Lan Nguyen)",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Venus_de_Milo_Louvre_Ma399_n4.jpg",
  },
  {
    sujet: "La Marseillaise (Le Départ des volontaires de 1792), François Rude († 1855), Arc de Triomphe, Paris",
    usage: "Lexique — Haut-relief",
    photographe: "Jebulon",
    licence: "CC0",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Le_D%C3%A9part_des_Volontaires_(La_Marseillaise)_par_Rude,_Arc_de_Triomphe_Etoile_Paris.jpg",
  },
  {
    sujet: "Umberto Boccioni, « Formes uniques de la continuité dans l'espace », 1913, bronze, Metropolitan Museum of Art",
    usage: "Lexique — Abstrait",
    photographe: "Metropolitan Museum of Art",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Unique_Forms_of_Continuity_in_Space_MET_DT6411.jpg",
  },
  {
    sujet: "L'armature de fer d'Eiffel dans le bras de la Statue de la Liberté, photo HAER",
    usage: "Lexique — Armature",
    photographe: "Jet Lowe, HAER",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:ARMATURE_AND_FRAMEWORK_LOOKING_DOWN_FROM_INSIDE_THE_ARM._-_Statue_of_Liberty,_Liberty_Island,_Manhattan,_New_York,_New_York_County,_NY_HAER_NY,31-NEYO,89-219.tif",
  },
  {
    sujet: "Assemblage provisoire de la Statue de la Liberté, atelier Gaget-Gauthier, Paris, 1883",
    usage: "Lexique — Assemblage",
    photographe: "Albert Fernique († 1898), photogravure 1883",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Provisional_assembly_of_the_Statue_of_Liberty_in_Paris,_1883.jpg",
  },
  {
    sujet: "Bronze de la base du « Persée » de Benvenuto Cellini, Loggia dei Lanzi, Florence",
    usage: "Lexique — Bronze",
    photographe: "Rufus46",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Perseus,_Benvenuto_Cellini,_Loggia_dei_Lanzi_Florenz-07.jpg",
  },
  {
    sujet: "Cachet du fondeur Henry-Bonnard Bronze Co., New-York 1887, sur la statue d'Ambrose Burnside (Providence)",
    usage: "Lexique — Certificat d'authenticité",
    photographe: "Kenneth C. Zirkel",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Foundry_mark_on_Ambrose_Burnside_Statue_in_Burnside_Park.jpg",
  },
  {
    sujet: "Cire perdue : le modèle en cire équipé de son réseau de jets, prêt pour le moule réfractaire",
    usage: "Lexique — Cire perdue",
    photographe: "Sailko",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Fusione_di_un_bronzo_a_cera_persa,_fase_3.JPG",
  },
  {
    sujet: "Les neuf étapes de la coulée directe à la cire perdue (schéma)",
    usage: "Lexique — Cire perdue (schéma)",
    photographe: "Verbex",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Etapes_cire_perdue.png",
  },
  {
    sujet: "Objet en bronze en cours de ciselure au boulet, atelier de bronze du Mobilier national",
    usage: "Lexique — Ciselure",
    photographe: "PaulineR83, Mobilier national",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Objet_en_bronze_en_cours_de_ciselure_-_Mobilier_national.jpg",
  },
  {
    sujet: "Une vente aux enchères, gravure de Charles Maurand, XIXe siècle (BnF)",
    usage: "Lexique — Cotation",
    photographe: "Charles Maurand († 1904), BnF",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Vente_aux_enchères,_G.22377.jpg",
  },
  {
    sujet: "Cachet « Cire perdue A.-A. Hébrard » gravé sur un bronze : la marque du fondeur d'art qui accompagne numéros d'épreuve et mentions EA",
    usage: "Lexique — Épreuve d'artiste",
    photographe: "Paris 16",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Fonderie_Hébrard_signature_(cropped).jpg",
  },
  {
    sujet: "La Vénus de Willendorf, v. 25 000 av. J.-C., calcaire, Naturhistorisches Museum, Vienne",
    usage: "Lexique — Figuratif",
    photographe: "Matthias Kabel",
    licence: "CC BY 2.5",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Venus_von_Willendorf_01.jpg",
  },
  {
    sujet: "Coulée du bronze en fusion dans une fonderie, photographie ancienne (Pays-Bas)",
    usage: "Lexique — Fonte",
    photographe: "Anonyme, photographie ancienne",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:In_een_fabriek_bij_een_grote_open_haard_staat_een_man_die_met_vloeibaar_materiaal_brons_de,_SFA022005458.jpg",
  },
  {
    sujet: "Une salle d'exposition : l'espace nu que l'installation vient investir et transformer",
    usage: "Lexique — Installation",
    photographe: "Selbymay",
    licence: "CC BY 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Museum_Barberini_Innenraum_leer.jpg",
  },
  {
    sujet: "Le Bernin, « Habacuc et l'ange », bozzetto en terre cuite, v. 1655",
    usage: "Lexique — Maquette",
    photographe: "Fabrizio Garrisi",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_Lorenzo_Bernini,_Abacuc_e_l'angelo,_bozzetto,_1655_circa_-FG.jpg",
  },
  {
    sujet: "Auguste Rodin, « La Main de Dieu », v. 1896-1902, marbre, Metropolitan Museum of Art",
    usage: "Lexique — Modelage",
    photographe: "Metropolitan Museum of Art",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:The_Hand_of_God_MET_DT2509.jpg",
  },
  {
    sujet: "L'atelier de Bartholdi à Paris, avec les maquettes de la Statue de la Liberté",
    usage: "Lexique — Monumental",
    photographe: "New York Public Library",
    licence: "Aucune restriction connue",
    creditUrl: "https://commons.wikimedia.org/wiki/File:(View_of_the_workshop,_with_models_of_the_Statue_of_Liberty_-_(3110144440).jpg",
  },
  {
    sujet: "Moules de fonderie en pierre, âge du bronze (1700-1200 av. J.-C.)",
    usage: "Lexique — Moule",
    photographe: "Bjoertvedt",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Bronze_age_1700-1200BC_IMG_1024_moulds.JPG",
  },
  {
    sujet: "Camille Claudel, « La Valse », 1889-1905, bronze patiné",
    usage: "Lexique — Patine",
    photographe: "Anonyme",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Camille_Claudel,_\"La_Valse\",_1889-1905,_bronze_fonte_(1).jpg",
  },
  {
    sujet: "Moulages en plâtre d'après l'Antique, gipsoteca du Liceo Dosso Dossi, Ferrare",
    usage: "Lexique — Plâtre",
    photographe: "Nicola Quirico",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Gipsoteca,_Liceo_Artistico_Dosso_Dossi,_Ferrara.jpg",
  },
  {
    sujet: "Lucy the Elephant, bâtiment-enseigne géant de 1881, Margate City (New Jersey) — l'objet agrandi, ancêtre du pop",
    usage: "Lexique — Pop art",
    photographe: "Acroterion",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lucy_the_Elephant_NJ3.jpg",
  },
  {
    sujet: "Objets en résine au démoulage : coulée, inclusion et couleurs franches",
    usage: "Lexique — Résine",
    photographe: "Aisha Moshood Nifemi",
    licence: "CC BY 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Resin_crafts.jpg",
  },
  {
    sujet: "Fontaine Wallace, place Louis-Lépine, Paris — la sculpture dans l'espace public",
    usage: "Lexique — Sculpture urbaine",
    photographe: "Mbzt",
    licence: "CC BY 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:P1030930_Paris_IV_fontaines_Wallace_de_la_place_Louis-Lépine_rwk.JPG",
  },
  {
    sujet: "Plinthe en calcaire portant les pieds d'une statue colossale, Antiquité, Metropolitan Museum",
    usage: "Lexique — Socle",
    photographe: "Metropolitan Museum of Art",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Limestone_plinth_with_the_feet_of_a_colossal_male_statue_MET_DP212768.jpg",
  },
  {
    sujet: "Un sculpteur taillant un relief dans la pierre, photographie ancienne (Bain News Service)",
    usage: "Lexique — Taille directe",
    photographe: "Bain News Service, Library of Congress",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Stone_sculptor_at_work.jpg",
  },
  {
    sujet: "Figurine de Tanagra, terre cuite moulée, Grèce, IIIe siècle av. J.-C., Blanton Museum of Art",
    usage: "Lexique — Terre cuite",
    photographe: "Daderot",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Statuette_(Tanagra_figurine),_Greek,_3rd_century_BC,_molded_terracotta_-_Blanton_Museum_of_Art_-_Austin,_Texas_-_DSC07615.jpg",
  },
  {
    sujet: "Antoine-Louis Barye, « Thésée combattant le Minotaure », bronze d'édition, musée Fabre",
    usage: "Lexique — Tirage limité",
    photographe: "Finoskov, musée Fabre",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:SculpturesMuséeFabre31a_Barye_Thésée_&_Minotaure.jpg",
  },
  {
    sujet: "Étape 1 — Le modèle original, ici en plâtre",
    usage: "Matériaux & techniques — cire perdue, étape 1",
    photographe: "José-Manuel Benito",
    licence: "CC BY-SA 2.5",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Model_of_apple_in_plaster.jpg",
  },
  {
    sujet: "Étape 2 — La prise d'empreinte sur le modèle",
    usage: "Matériaux & techniques — cire perdue, étape 2",
    photographe: "José-Manuel Benito",
    licence: "CC BY-SA 2.5",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Moldmaking_of_an_apple.jpg",
  },
  {
    sujet: "Étape 3 — La cire, tirée de l'empreinte, avec sa tige de coulée",
    usage: "Matériaux & techniques — cire perdue, étape 3",
    photographe: "José-Manuel Benito",
    licence: "CC BY-SA 2.5",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Model_of_apple_in_paraffine.jpg",
  },
  {
    sujet: "Étape 4 — Le four de la fonderie : la cire s'élimine, le moule cuit",
    usage: "Matériaux & techniques — cire perdue, étape 4",
    photographe: "Jet Lowe, HAER",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:INTERIOR,_FOUNDRY,_CASTING_FLOOR,_FURNACE_IN_CONTEXT_-_Ricks_Foundry,_Foundry_Building,_Miller_Avenue_off_South_Mount_Vernon_Street,_Uniontown,_Fayette_County,_PA_HAER_PA,26-UNITO,1A-3.tif",
  },
  {
    sujet: "Étape 5 — La coulée du métal en fusion, photographie ancienne",
    usage: "Matériaux & techniques — cire perdue, étape 5",
    photographe: "Armstrong Whitworth, photographie ancienne",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Pouring_molten_metal_from_the_crucible_pot_into_the_ingot_moulds,_(HS85-10-32646).jpg",
  },
  {
    sujet: "Étape 6 — Le bronze brut de coulée, avant ébarbage et finition",
    usage: "Matériaux & techniques — cire perdue, étape 6",
    photographe: "José-Manuel Benito",
    licence: "CC BY-SA 2.5",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Lost_Wax-Apple_in_bronze.jpg",
  },
  {
    sujet: "Le modèle original — ici un plâtre d'Auguste Rodin, « La Mort d'Adonis », Walters Art Museum",
    usage: "Fiche matériau Bronze — étape 1",
    photographe: "Walters Art Museum",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Auguste_Rodin_-_The_Death_of_Adonis_-_Walters_27491.jpg",
  },
  {
    sujet: "« Fonte des statues équestres », plan et profil de la fonderie, planche de l'Encyclopédie de Diderot et d'Alembert",
    usage: "Fiche matériau Bronze — étape 2",
    photographe: "Robert Bénard, planche de l'Encyclopédie",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Encyclopedie_volume_7-287.png",
  },
  {
    sujet: "Bronzes fixés dans le ciment sur les boulets du ciseleur, atelier du Mobilier national",
    usage: "Fiche matériau Bronze — étape 3",
    photographe: "PaulineR83, Mobilier national",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Objets_en_bronze_pris_dans_le_ciment_sur_le_boulet_de_ciseleur_-_Mobilier_national.jpg",
  },
  {
    sujet: "« Le Chinois », bronze à patine colorée de Jean-Baptiste Carpeaux, fonderie Susse, v. 1872",
    usage: "Fiche matériau Bronze — étape 4",
    photographe: "Daderot",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:The_Chinese_Man_by_Jean-Baptiste_Carpeaux,_foundry_Susse_Freres,_c._1872,_bronze_with_colored_patination_on_marble_base_-_California_Palace_of_the_Legion_of_Honor_-_San_Francisco,_CA_-_DSC00070.jpg",
  },
  {
    sujet: "Le chalumeau à bouche (fig. 5), planche « Orfèvre Bijoutier, outils » de l'Encyclopédie, 1771",
    usage: "Fiche matériau Bronze — outil de la patine",
    photographe: "Dessin de Lucotte, gravure de Robert Bénard (né 1734)",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Recueil_de_planches,_sur_les_sciences,_les_arts_libéraux,_et_les_arts_méchaniques_-_avec_leur_explication_(1771)_(14784050915).jpg",
  },
  {
    sujet: "L'original, sculpté avant tout moulage — ici un modello en terre cuite du Bernin, v. 1650",
    usage: "Fiche matériau Résine — étape 1",
    photographe: "Sailko",
    licence: "CC BY 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Gian_lorenzo_bernini,_leone_che_si_abbevera,_modello_in_terracotta_per_la_fontana_dei_fiumi.JPG",
  },
  {
    sujet: "Le modèle, le moule à pièces ouvert et le tirage, réunis par le mouleur Jacques Laurent (MOF)",
    usage: "Fiche matériau Résine — étape 2",
    photographe: "Jacques Laurent",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Moule_de_la_Vierge_au_Boulanger_par_Jacques_Laurent_MOF.jpg",
  },
  {
    sujet: "La coulée dans une série de moules, en atelier (ici en céramique : le geste est le même)",
    usage: "Fiche matériau Résine — étape 3",
    photographe: "Encik Tekateki",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Slip_Casting_di_kilang_Claytan.png",
  },
  {
    sujet: "Une résine poncée et polie, au rendu opalescent",
    usage: "Fiche matériau Résine — étape 4",
    photographe: "James St. John",
    licence: "CC BY 2.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:\"Aurora_Borealis\"_-_manmade_opalescent_resin_17_-_54574391208.jpg",
  },
  {
    sujet: "Le gâchage du plâtre, gravure ancienne (Wellcome Collection)",
    usage: "Fiche matériau Plâtre — étape 1",
    photographe: "Wellcome Collection",
    licence: "CC BY 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:One_man_is_mixing_plaster_on_a_board_on_the_floor_and_anothe_Wellcome_V0039549.jpg",
  },
  {
    sujet: "Moulage en plâtre d'après l'Antique (Hermès portant Dionysos)",
    usage: "Fiche matériau Plâtre — étape 2",
    photographe: "Finoskov",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Moulages_Antique12_Hermès_&_Dionysos.jpg",
  },
  {
    sujet: "Modèle en plâtre d'une tête de bison, sculpté par Alexander Phimister Proctor (1909)",
    usage: "Fiche matériau Plâtre — étape 3",
    photographe: "National Park Service",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Plaster_model_of_a_bison_head_sculpted_by_Alexander_Phimister_Proctor_and_given_to_Theodore_Roosevelt._In_1909,_Theodore_(ff31c65e-b5ed-488a-bc8e-11a34399b3c4).JPG",
  },
  {
    sujet: "Une sculpture en plâtre achevée, Auckland Museum",
    usage: "Fiche matériau Plâtre — étape 4",
    photographe: "Auckland Museum",
    licence: "CC BY 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Sculpture,_plaster_(AM_53809-16).jpg",
  },
  {
    sujet: "La découpe plasma d'une tôle d'acier",
    usage: "Fiche matériau Métal — étape 1",
    photographe: "Diego Baron Carral",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Corte_por_plasma.jpg",
  },
  {
    sujet: "Le formage du métal au marteau, gravure de Domenico Beccafumi (XVIe siècle)",
    usage: "Fiche matériau Métal — étape 2",
    photographe: "Domenico Beccafumi († 1551)",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Beccafumi_-_8_Producing_small_metal_items.jpg",
  },
  {
    sujet: "La soudure à l'arc d'une tôle d'acier",
    usage: "Fiche matériau Métal — étape 3",
    photographe: "Kgequipment",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Welding_Steel_Plate.JPG",
  },
  {
    sujet: "Le meulage des assemblages à la meuleuse d'angle",
    usage: "Fiche matériau Métal — étape 4",
    photographe: "Adygrafix250",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:A_welder_using_an_angle_grinder_to_grind_steel.jpg",
  },
  {
    sujet: "Le choix de la pièce : planches et outils sur l'établi",
    usage: "Fiche matériau Bois — étape 1",
    photographe: "A S M Jobaer",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Woodworking_hand_tools_on_timber_planks_01.jpg",
  },
  {
    sujet: "Le dégrossissage d'un billot à la tronçonneuse",
    usage: "Fiche matériau Bois — étape 2",
    photographe: "Mike Smith",
    licence: "CC BY 2.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Jonnychainsaw_during_a_chainsaw_art_demonstration_at_Muiravonside.jpg",
  },
  {
    sujet: "Un sculpteur sur bois au travail, Japon, 1914",
    usage: "Fiche matériau Bois — étape 3",
    photographe: "Elstner Hilton, 1914",
    licence: "CC BY 2.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Master_Wood_Carver_at_Work_in_Japan_(1914_by_Elstner_Hilton).jpg",
  },
  {
    sujet: "Ciseaux, gouges et ébauchoirs à bois sur l'établi",
    usage: "Fiche matériau Bois — outils",
    photographe: "David Adam Kess",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Topmast_Studio_(WORKSHOP)_Swiss_Tools_at_the_workbench_Pfeil_Wood_Carving_Tools_Gouges,_Chisels,_Carving_Sets_(pic.z2).jpg",
  },
  {
    sujet: "Le ponçage, première étape de la finition du bois",
    usage: "Fiche matériau Bois — étape 4",
    photographe: "Thiam Babel Design",
    licence: "CC0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Ponçage_du_bois._2.jpg",
  },
  {
    sujet: "Le choix du bloc : carrière de marbre de Carrare",
    usage: "Fiche matériau Pierre — étape 1",
    photographe: "Vmenkov",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Blocks_of_marble_in_Carrara_marble_quarry_6386.jpg",
  },
  {
    sujet: "Le dégrossissage : la forme commence à émerger du bloc",
    usage: "Fiche matériau Pierre — étape 2",
    photographe: "Carptrash",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Roughed_out.jpg",
  },
  {
    sujet: "Un tailleur de pierre au travail, chantier de Guédelon",
    usage: "Fiche matériau Pierre — étape 3",
    photographe: "Schorle",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Stonemason_at_Guedelon.jpg",
  },
  {
    sujet: "Traces de gradine sur la pierre : l'outil nivelle et adoucit la surface",
    usage: "Fiche matériau Pierre — outil",
    photographe: "A.-K. D.",
    licence: "CC BY-SA 4.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Claw_tool_marks_Johns_Priory.jpg",
  },
  {
    sujet: "Les outils de la finition : râpes, gradines et ciseaux du tailleur de pierre",
    usage: "Fiche matériau Pierre — étape 4",
    photographe: "Magdales",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Musee_lado_outil_tailleur_pierre.jpg",
  },
  {
    sujet: "« La Forge », eau-forte de Charles-Émile Jacque, 1848 (New York Public Library)",
    usage: "Partenaires — ferronnerie",
    photographe: "Charles-Émile Jacque († 1894), eau-forte 1848, NYPL",
    licence: "Domaine public — mire du scan rognée",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Forge_(NYPL_b14917537-1219179).jpg",
  },
  {
    sujet: "La soudure à l'arc sur poutrelles d'acier",
    usage: "Partenaires — ferronnerie",
    photographe: "muygocho",
    licence: "CC BY-SA 2.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Red_Lincoln_welding_plant_and_welder_working_on_some_steel_beams.jpg",
  },
  {
    sujet: "La découpe de tôle, en gerbes d'étincelles",
    usage: "Partenaires — ferronnerie",
    photographe: "Carlos Castaneda Giron",
    licence: "CC BY-SA 3.0",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Cortadora_de_metal.JPG",
  },
  {
    sujet: "L'atelier de la fonderie d'une statue équestre et son four, planche de l'Encyclopédie de Diderot et d'Alembert",
    usage: "Fiche matériau Bronze — image d'en-tête (coulée du métal)",
    photographe: "Robert Bénard (né 1734), planche de l'Encyclopédie",
    licence: "Domaine public",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Encyclopedie_volume_7-286.png",
  },
  {
    sujet: "Sculpture bronze « vague », Fonderie du Péroux",
    usage: "Fiche partenaire « Fonderie du Péroux » — vignette annuaire et fiche (logo)",
    photographe: "Image fournie par la Fonderie du Péroux",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://sculpteur-francais.com/partenaires/fonderie-art/fonderie-du-peroux",
  },
  {
    sujet: "Sculpture bronze, Fonderie du Péroux à Vonnas",
    usage: "Fiche partenaire « Fonderie du Péroux » — photo 2",
    photographe: "Image fournie par la Fonderie du Péroux",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://sculpteur-francais.com/partenaires/fonderie-art/fonderie-du-peroux",
  },
  {
    sujet: "Sculpture bronze d'enfant, Fonderie du Péroux Vonnas",
    usage: "Fiche partenaire « Fonderie du Péroux » — photo 3",
    photographe: "Image fournie par la Fonderie du Péroux",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://sculpteur-francais.com/partenaires/fonderie-art/fonderie-du-peroux",
  },
  {
    sujet: "Logo Petit-Barat Polyester, atelier de moulage d'art contemporain",
    usage: "Fiche partenaire « Petit-Barat Polyester » — vignette annuaire et tête de fiche",
    photographe: "Image fournie par Petit-Barat Polyester",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://petitbaratpolyester.com/",
  },
  {
    sujet: "Sculpture singe rouge en polyester laqué, Petit-Barat",
    usage: "Fiche partenaire « Petit-Barat Polyester » — photo 1",
    photographe: "Image fournie par Petit-Barat Polyester",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://petitbaratpolyester.com/",
  },
  {
    sujet: "Sculptures sphères en résine, Petit-Barat, Montaigut-en-Combraille",
    usage: "Fiche partenaire « Petit-Barat Polyester » — photo 2",
    photographe: "Image fournie par Petit-Barat Polyester",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://petitbaratpolyester.com/",
  },
  {
    sujet: "Sculpture gorille en résine, atelier Petit-Barat",
    usage: "Fiche partenaire « Petit-Barat Polyester » — photo 3",
    photographe: "Image fournie par Petit-Barat Polyester",
    licence: "Droits fournis par le partenaire",
    creditUrl: "https://petitbaratpolyester.com/",
  },
  {
    sujet: "Sculpture cavalier d'échecs monumental en résine, Evoludis Concept",
    usage: "Rubrique Résine — vignette de la carte partenaire Evoludis Concept",
    photographe: "Image fournie par l'utilisateur",
    licence: "Droits fournis",
    creditUrl: "https://sculpteur-francais.com/partenaires/resine",
  },
  {
    sujet: "Arbre sculptural en métal forgé, atelier Art de Forge",
    usage: "Rubrique Ferronnerie — vignette de la carte Jérôme Mazoyer Art de Forge, et tête de fiche",
    photographe: "Image fournie par l'utilisateur",
    licence: "Droits fournis",
    creditUrl: "https://sculpteur-francais.com/partenaires/ferronnerie",
  },
];
